import { GtmLobbyName } from "@obg/gtm.types/adaptive";
import { TrackingData } from "@obg/ngx.core";

import {
	CASINO_ROUTES,
	JACKPOTS_ROUTES,
	LIVE_CASINO_ROUTES,
	POKER_ROUTES,
	SLOTS_ROUTES,
	SPORTSBOOK_THIRDPARTY_LIVE_ROUTES,
	SPORTSBOOK_THIRDPARTY_ROUTES,
	TURKISH_POKER_ROUTES,
	VIRTUAL_SPORTS_ROUTES,
} from "../route";

const GAMING_LOBBY_TRACKING_DATA = {
	casino: {
		lobbyName: GtmLobbyName.Casino,
	},
	liveCasino: {
		lobbyName: GtmLobbyName.LiveCasino,
	},
	poker: {
		lobbyName: GtmLobbyName.Poker,
	},
	turkishPoker: {
		lobbyName: GtmLobbyName.Poker,
	},
	jackpots: {
		lobbyName: GtmLobbyName.Jackpots,
	},
	virtualSports: {
		lobbyName: GtmLobbyName.VirtualSports,
	},
	sport: {
		lobbyName: GtmLobbyName.Sportsbook,
	},
	sportLive: {
		lobbyName: GtmLobbyName.LiveSportsbook,
	},
};

export const GAMING_TRACKING_DATA: Record<string, TrackingData> = {
	[CASINO_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.casino,
		lobby: true,
	},
	[CASINO_ROUTES.gameLauncher]: GAMING_LOBBY_TRACKING_DATA.casino,
	[CASINO_ROUTES.gameLauncherAutoplay]: GAMING_LOBBY_TRACKING_DATA.casino,
	[CASINO_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.casino,
	[CASINO_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.casino,
	[CASINO_ROUTES.favorites]: GAMING_LOBBY_TRACKING_DATA.casino,

	[LIVE_CASINO_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.liveCasino,
		lobby: true,
	},
	[LIVE_CASINO_ROUTES.gameLauncher]: GAMING_LOBBY_TRACKING_DATA.liveCasino,
	[LIVE_CASINO_ROUTES.gameLauncherAutoplay]: GAMING_LOBBY_TRACKING_DATA.liveCasino,
	[LIVE_CASINO_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.liveCasino,
	[LIVE_CASINO_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.liveCasino,
	[LIVE_CASINO_ROUTES.favorites]: GAMING_LOBBY_TRACKING_DATA.liveCasino,

	[POKER_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.poker,
		lobby: true,
	},
	[POKER_ROUTES.alias]: GAMING_LOBBY_TRACKING_DATA.poker,
	[POKER_ROUTES.game]: GAMING_LOBBY_TRACKING_DATA.poker,
	[POKER_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.poker,
	[POKER_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.poker,
	[TURKISH_POKER_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.turkishPoker,
		lobby: true,
	},
	[TURKISH_POKER_ROUTES.alias]: GAMING_LOBBY_TRACKING_DATA.turkishPoker,
	[TURKISH_POKER_ROUTES.game]: GAMING_LOBBY_TRACKING_DATA.turkishPoker,
	[TURKISH_POKER_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.turkishPoker,
	[TURKISH_POKER_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.turkishPoker,
	[JACKPOTS_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.jackpots,
		lobby: true,
	},
	[JACKPOTS_ROUTES.gameLauncher]: GAMING_LOBBY_TRACKING_DATA.jackpots,
	[JACKPOTS_ROUTES.gameLauncherAutoplay]: GAMING_LOBBY_TRACKING_DATA.jackpots,
	[JACKPOTS_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.jackpots,
	[JACKPOTS_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.jackpots,
	[JACKPOTS_ROUTES.favorites]: GAMING_LOBBY_TRACKING_DATA.jackpots,
	[VIRTUAL_SPORTS_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.virtualSports,
		lobby: true,
	},
	[VIRTUAL_SPORTS_ROUTES.gameLauncher]: GAMING_LOBBY_TRACKING_DATA.virtualSports,
	[VIRTUAL_SPORTS_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.virtualSports,
	[VIRTUAL_SPORTS_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.virtualSports,
	[VIRTUAL_SPORTS_ROUTES.favorites]: GAMING_LOBBY_TRACKING_DATA.virtualSports,
	[SLOTS_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.casino,
		lobby: true,
	},
	[SLOTS_ROUTES.gameLauncher]: GAMING_LOBBY_TRACKING_DATA.casino,
	[SLOTS_ROUTES.gameLauncherAutoplay]: GAMING_LOBBY_TRACKING_DATA.casino,
	[SLOTS_ROUTES.search]: GAMING_LOBBY_TRACKING_DATA.casino,
	[SLOTS_ROUTES.categories]: GAMING_LOBBY_TRACKING_DATA.casino,
	[SLOTS_ROUTES.favorites]: GAMING_LOBBY_TRACKING_DATA.casino,
	[SPORTSBOOK_THIRDPARTY_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.sport,
		lobby: true,
	},
	[SPORTSBOOK_THIRDPARTY_ROUTES.destination]: GAMING_LOBBY_TRACKING_DATA.sport,
	[SPORTSBOOK_THIRDPARTY_ROUTES.event]: GAMING_LOBBY_TRACKING_DATA.sport,
	[SPORTSBOOK_THIRDPARTY_ROUTES.subevent]: GAMING_LOBBY_TRACKING_DATA.sport,
	[SPORTSBOOK_THIRDPARTY_LIVE_ROUTES.lobby]: {
		...GAMING_LOBBY_TRACKING_DATA.sportLive,
		lobby: true,
	},
	[SPORTSBOOK_THIRDPARTY_LIVE_ROUTES.event]: GAMING_LOBBY_TRACKING_DATA.sportLive,
};
